import { render, staticRenderFns } from "./ZEvents.vue?vue&type=template&id=5a01fc5a&scoped=true&"
import script from "./ZEvents.vue?vue&type=script&lang=js&"
export * from "./ZEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01fc5a",
  null
  
)

export default component.exports